import { render, staticRenderFns } from "./PDPCarePlan.vue?vue&type=template&id=22688cde&scoped=true&"
import script from "./PDPCarePlan.vue?vue&type=script&lang=ts&"
export * from "./PDPCarePlan.vue?vue&type=script&lang=ts&"
import style0 from "./PDPCarePlan.vue?vue&type=style&index=0&id=22688cde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22688cde",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AtomsCheckbox: require('/var/www/packages/theme/components/atoms/CheckboxComponent/Checkbox.vue').default,IconsInfoCircle24px: require('/var/www/packages/theme/components/icons/info-circle/InfoCircle24px.vue').default,IconsSpinner: require('/var/www/packages/theme/components/icons/spinner/Spinner.vue').default,MoleculesCarePlanDrawer: require('/var/www/packages/theme/components/molecules/CarePlanDrawer.vue').default})
